import { ElementAttribute } from "./ElementAttribute";
import { Loader } from "./Loader";

export enum ImageLoaderMode
{
  REPLACE_BACKGROUND_IMAGE_URL,
  APPEND_IMG_ELEMENT
}

export class ImageLoader
{
  static readonly pointableAttribute = new ElementAttribute( "pointable" );
  static readonly loaderSelector = "input[type=\"file\"]";
  static readonly modeAttribute      = new ElementAttribute( "mode" );
  static readonly targetAttribute    = new ElementAttribute( "target" );

  static applyOnDocument( selector:string )
  {
    let elements = document.querySelectorAll( selector );

    for ( let i = 0; i < elements.length; i++ )
    {
      ImageLoader.applyOnElement( elements[ i ] );
    }
  }

  static applyOnElement( element:Element )
  {
    let pointable = ImageLoader.pointableAttribute.queryValueIn( element, document );
    let mode      = parseInt( ImageLoader.modeAttribute.from( element ) || "0" ) as ImageLoaderMode;
    let target   = ImageLoader.targetAttribute.queryValueIn( element, document ) as HTMLElement;

    let loader    = element.querySelector( ImageLoader.loaderSelector ) as HTMLInputElement;


    pointable.addEventListener( "click", ()=>{ loader.click() } );

    let resetLoader = () => 
    {
      loader.src = null;
      loader.value = null;
    }

    let replaceBackgroundImageURL = async () =>
    {
      let fileReader = await Loader.readDataURL( loader.files[ 0 ] );
      target.style.backgroundImage = "url(" +  fileReader.result + ")";
      resetLoader();
    };

    let appendIMGElement = async () =>
    {
      let fileReader = await Loader.readDataURL( loader.files[ 0 ] );
      target.style.backgroundImage = "url(" +  fileReader.result + ")";
      var img = document.createElement( "img" ) as HTMLImageElement;
      img.src = fileReader.result as string;
      target.appendChild( img );
      resetLoader();
    };

    if ( ImageLoaderMode.REPLACE_BACKGROUND_IMAGE_URL === mode )
    {
      loader.addEventListener( "change", replaceBackgroundImageURL );
    }
    else if ( ImageLoaderMode.APPEND_IMG_ELEMENT === mode )
    {
      loader.addEventListener( "change", appendIMGElement );
    }

  }
}